<template>
    <Modal width="420" v-model="passwordModel.show" title="修改密码">
        <Form :label-width="80">
            <FormItem label="密码">
                <Input type="password" v-model="passwordModel.password"/>
            </FormItem>
            <FormItem label="确认密码">
                <Input type="password" v-model="passwordModel.enterPassword"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" @click="onConfirm(passwordModel)">确定</Button>
        </div>
    </Modal>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                passwordModel: {
                    show: false,
                    password: '',
                    enterPassword: '',
                }
            }
        },
        mounted() {
            this.$bus.on('changePassword', (data)=>{
                if (data){
                    this.passwordModel.show = data;
                }
            });
        },
        methods: {
            onCancel(){
                this.passwordModel.show = false;
            },
            async onConfirm(data){
                if (!data.password || data.password !== data.enterPassword){
                    this.$Message.error('密码不能为空 & 两次输入密码不一致');
                    return false;
                }
                let res = await this.$api.postHttp('user/modifyPassword/' + this.$store.state.account.user.id, data.password);
                if (res.data.code !== 0){
                    this.$Message.error(res.data.msg);
                    return false;
                }
                this.$Message.success(res.data.msg);
                this.onCancel();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Password.vue